module.exports = __webpack_public_path__ + "static/media/mt-ut-img-13.4be8edc9.webp";